import { useT } from '@spotify-internal/i18n-core';

export const useApprovalStatusCopy = () => {
  const t = useT();

  return {
    columnHeader: t(
      'atlas.labels.approval_status',
      'Approval status',
      'Label for Approval status column header in the Track contributors table',
    ),
    infoButtonLabel: t(
      'atlas.approval_status.info_button_label',
      'Learn about approval statuses',
      'Aria label for the approval status info icon button',
    ),
    approved: t(
      'atlas.approval_status.approved',
      'Approved',
      'Approval status: approved',
    ),
    approvedDescription: t(
      'atlas.approval_status.approved_description',
      'Main artist(s) approved or pre-approved the release.',
      'Description for the Approved approval status',
    ),
    declined: t(
      'atlas.approval_status.declined',
      'Declined',
      'Approval status: declined',
    ),
    declinedDescription: t(
      'atlas.approval_status.declined_description',
      'Main artist(s) declined the release.',
      'Description for the Declined approval status',
    ),
    partiallyApproved: t(
      'atlas.approval_status.partially_approved',
      'Partially approved',
      'Approval status: partially approved',
    ),
    partiallyApprovedDescription: t(
      'atlas.approval_status.partially_approved_description',
      'One or more main artists declined, and one or more main artists approved the release.',
      'Description for the Partially approved approval status',
    ),
    needsApproval: t(
      'atlas.approval_status.needs_approval',
      'Needs approval',
      'Approval status: needs approval',
    ),
    needsApprovalDescription: t(
      'atlas.approval_status.needs_approval_description',
      'One or more main artists still need to approve the release, and they have up to 28 days after the release date to do so.',
      'Description for the Needs approval approval status',
    ),
    expired: t(
      'atlas.approval_status.expired',
      'Expired',
      'Approval status: expired',
    ),
    expiredDescription: t(
      'atlas.approval_status.expired_description',
      'One or more main artists did not approve the release before the approval window closed.',
      'Description for the Expired approval status',
    ),
    noApprovalNeeded: t(
      'atlas.approval_status.no_approval_needed',
      'No approval needed',
      'Approval status: no approval needed',
    ),
    noApprovalNeededDescription: t(
      'atlas.approval_status.no_approval_needed_description',
      'No main artists have turned on Artist Profile Protection.',
      'Description for the No approval needed approval status',
    ),
  };
};
